import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  sectionWrapper: {
    backgroundColor: palette.shades[100]
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  progress: {
    width: '100%',
    height: '10px',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    margin: '0 18px',
    [breakpointsFunc.breakpoints.down('md')]: {
      margin: '10px 0'
    }
  },
  progressPartial: {
    flexGrow: '1',
    height: '10px',
    '&:first-child': {
      borderRadius: '10px 0 0 10px'
    },
    '&:last-child': {
      borderRadius: '0 10px 10px 0'
    }
  },
  activeStep: {
    backgroundColor: palette.primary.main,
    '& + $unactiveStep': {
      borderLeft: "3px solid ".concat(palette.shades[200])
    }
  },
  unactiveStep: {
    backgroundColor: palette.shades[500]
  },
  rationBillingSection: {
    padding: '24px 32px',
    borderLeft: "1px solid ".concat(palette.shades[300]),
    borderRight: "1px solid ".concat(palette.shades[300]),
    borderBottom: "1px solid ".concat(palette.shades[300]),
    borderRadius: '0 0 2px 2px'
  },
  ratioBilling: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
    // NOTE: Currently Disabled because usage of tiers is suspended
    // paddingBottom: '24px',
    // borderBottom: `1px solid ${palette.shades[300]}`,
    // marginBottom: '24px',
  },
  section: {
    padding: '24px 32px',
    background: palette.brandGradients.fade,
    borderRadius: '2px 2px 0 0',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& + $subSection': {
      borderTop: 'none'
    }
  },
  subSection: {
    padding: '24px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: "1px solid ".concat(palette.shades[300]),
    '& + &': {
      borderTop: 'none'
    },
    '&:last-child': {
      borderRadius: '0 0 2px 2px'
    }
  },
  lastSection: {
    borderRadius: '0 0 2px 2px'
  },
  propertyConfigMode: {
    '& $section': {
      border: 'none',
      boxShadow: palette.shadows.light,
      background: palette.shades[100]
    },
    '& $rationBillingSection': {
      border: 'none'
    }
  }
}));
export default useStyles;